export default {
    data: function () {
        return {
            loadingCountries: false,
            loadingStates: false,
            countries: [],
            states: [],
            selectedCountry: null,
            selectedState: null,
        };
    },
    methods: {
        loadCountries: function () {
            this.loadingCountries = true;
            axios.get('/api/v1/countries/list')
                .then(response => {
                    this.countries = response.data.data;
                    this.loadStates();
                })
                .catch(error => console.error(error))
                .then(() => this.loadingCountries = false);
        },
        loadStates: function () {
            if (!this.selectedCountry) {
                this.states = [];
                this.selectedState = null;
                return;
            }
            this.loadingStates = true;
            axios.post('/api/v1/countries/states', {
                country: this.selectedCountry,
            })
                .then(response => {
                    this.states = response.data.data;
                })
                .catch(error => console.error(error))
                .then(() => this.loadingStates = false);
        },
    }
};
